import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/o-nas" as const,
	[Locale.en]: "/about-us" as const,
} satisfies LocalizedString;

export function getAboutUsPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
